/** @format */
import { defineStore, StoreDefinition } from 'pinia';
import Cookies from 'js-cookie';
import { store } from '@/store';

export const useAppStore: StoreDefinition = defineStore({
	id: 'p-components-app',
	state: () => ({
		sidebar: {
			opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
			withoutAnimation: false,
			hide: false,
		},
		device: 'desktop',
		size: Cookies.get('size') || 'default',
	}),
	actions: {
		toggleSideBar(withoutAnimation?: boolean) {
			if (this.sidebar.hide) {
				return false;
			}
			this.sidebar.opened = !this.sidebar.opened;
			this.sidebar.withoutAnimation = withoutAnimation || false;
			if (this.sidebar.opened) {
				Cookies.set('sidebarStatus', 1);
			} else {
				Cookies.set('sidebarStatus', 0);
			}
		},
		closeSideBar(withoutAnimation: boolean) {
			Cookies.set('sidebarStatus', 0);
			this.sidebar.opened = false;
			this.sidebar.withoutAnimation = withoutAnimation;
		},
		toggleDevice(device) {
			this.device = device;
		},
		setSize(size) {
			this.size = size;
			Cookies.set('size', size);
		},
		toggleSideBarHide(status) {
			this.sidebar.hide = status;
		},
	},
});

// 在组件setup函数外使用
export function useAppStoreWithOut(): any {
	return useAppStore(store);
}
